import { apiCall, jwtHeaders } from "./data";

export const getUserProfile = async () => {
  return apiCall("api/user/GetUserProfile", "GET"  );
};

export const getUserNotification = async () => {
  return apiCall("api/user/GetAllNotificationsofUser", "GET"  );
};

export const getGallery = async () => {
  return apiCall("api/admin/GetAllGallary", "GET"  );
};
export const getAllPost = async () => {
  return apiCall("api/admin/GetAllPost", "GET"  );
};
export const getTerms = async () => {
  return apiCall("api/admin/GetTermsandcondition", "GET"  );
};
export const getDonation = async () => {
  return apiCall("api/admin/GetAllDonation", "GET"  );
};
export const getPolicy = async () => {
  return apiCall("api/admin/GetPrivacyPolicy", "GET"  );
};

export const updateUserProfile = async (data) => {
  return apiCall("api/user/Updateuser", "PUT", data  );
};

// export const sendForgotPasswordOtp = async (data) => {
//   return apiCall("api/user/forgot/otpsend", "POST", data  );
// };

// export const resetPassword = async (data) => {
//   return apiCall("api/user/forgot/otpverify", "POST", data  );
// };

export const getallCampaign = async () => {
  return apiCall("api/admin/GetAllCampaign", "GET"  );
}
export const getAllProject = async () => {
  return apiCall("api/admin/GetAllProject", "GET"  );
}
export const getSingleProject = async (id) => {
  return apiCall(`api/admin/GetProjectDetail/${id}`, "GET"  );
}
export const getSingleDonation = async (id) => {
  return apiCall(`api/admin/GetACampaignDetail/${id}`, "GET"  );
}

// export const getallCategory = async () => {
//   return apiCall("api/category", "GET"  );
// }

export const getTodayEvents = async () => {
  return apiCall(`api/admin/GetTodayEvent`, "GET"  );
}

// Cart Related Apis 
// export const addToCart = async (data) => {
//   return apiCall("api/cart/add-to-cart", "POST", data);
// };
export const addToMoney = async (data) => {
  return apiCall("api/user/AddMoneyInWallet", "POST", data);
};
export const AddDonation = async (data) => {
  return apiCall("/api/user/UserAddDonation", "POST", data);
};

// export const removeFromCart = async (data) => {
//   return apiCall("api/cart/remove-from-cart", "POST", data);
// };

// export const getCartByUser = async () => {
//   return apiCall("api/cart/get-cart", "GET");
// };

// export const updateCartQuantity = async (data) => {
//   return apiCall("api/cart/update-quantity", "POST", data);
// };

// Wishlist Related Apis

export const addToLike = async (id) => {
  return apiCall(`api/user/LikeOrUnlikePost/${id}`, "GET");
};

export const removeToLike = async (id) => {
  return apiCall(`api/user/LikeOrUnlikePost/${id}`, "GET");
};

// export const getWishlistByUser = async () => {
//   return apiCall("api/wishlist", "GET");
// };

// export const moveToCart = async (data) => {
//   return apiCall("api/wishlist/move-to-cart", "POST", data);
// };


// Create Campain

export const CreateCampaign = async (data) => {
  return apiCall("api/admin/CreateCampaign", "POST", data);
};